import React, { useState, useCallback } from 'react';
import useTimeout from './node_modules/.pnpm/beautiful-react-hooks@3.12.2_react-dom@18.3.1_react@18.3.1__react-router-dom@7.1.2_react-dom@_7an4zy6qihkywxb5wsqpzmrq4e/node_modules/beautiful-react-hooks/esm/useTimeout.js';
import { ButtonClose } from './ButtonClose.js';
import { Icon } from './Icon.js';

function getTypeCss(type) {
    switch (type) {
        case 'positive':
            return 'border-green-500';
        case 'negative':
            return 'border-red';
        case 'danger':
            return 'border-yellow';
        default:
            return 'border-gray-300';
    }
}
const Alert = ({ animate = false, children, closeLabel = 'Close', hasIcon = true, id, onClose = () => null, persistent = false, shouldRemove = false, type = 'info', ...props }) => {
    const [visible, setVisible] = useState(true);
    const [isCleared, clearTimeoutRef] = useTimeout(() => {
        if (shouldRemove) {
            clearTimeoutRef();
            closeAlert();
        }
    }, 5000, { cancelOnUnmount: true });
    const closeAlert = useCallback(() => {
        if (shouldRemove && !isCleared) {
            clearTimeoutRef();
        }
        setVisible(false);
        onClose(id);
    }, [clearTimeoutRef, onClose, setVisible]);
    return visible ? (React.createElement("div", { "aria-live": "polite", role: "alert", className: [
            'flex',
            'justify-between',
            'shadow-lg',
            'w-full',
            'text-sm',
            'py-4',
            'pr-2',
            'pl-4',
            'border-l-4',
            'bg-white',
            'pointer-events-auto',
            animate ? 'animate-fade-in' : '',
            getTypeCss(type),
        ].join(' '), ...props },
        hasIcon && (React.createElement(Icon, { type: type, className: ['shrink-0', 'w-5', 'self-center', 'mr-3'].join(' ') })),
        React.createElement("div", { className: "pr-6 self-center grow grid gap-y-2" }, children),
        !persistent && React.createElement(ButtonClose, { onClick: closeAlert, label: closeLabel }))) : null;
};

export { Alert };
//# sourceMappingURL=Alert.js.map
